import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ID_TOKEN_COOKIE } from '../global-constants';
import { logger } from '../logger/logger';
import getLoggedInUserInfo from './getLoggedInUserInfo';
function getUnleashUserInfo(token, ccuiSession) {
  var _getLoggedInUserInfo = getLoggedInUserInfo(token),
    name = _getLoggedInUserInfo.name,
    _getLoggedInUserInfo$ = _getLoggedInUserInfo.profile,
    sessionId = _getLoggedInUserInfo$.sessionId,
    isBusiness = _getLoggedInUserInfo$.isBusiness,
    accessLevel = _getLoggedInUserInfo$.accessLevel,
    employeeId = _getLoggedInUserInfo$.employeeId,
    companyId = _getLoggedInUserInfo$.companyId,
    cdhCompanyId = _getLoggedInUserInfo.cdhCompanyId,
    cdhEmployeeId = _getLoggedInUserInfo.cdhEmployeeId,
    operaCompanyId = _getLoggedInUserInfo.operaCompanyId;
  return {
    name: ccuiSession !== null && ccuiSession !== void 0 ? ccuiSession : name,
    sessionId,
    isBusiness,
    accessLevel,
    employeeId,
    companyId,
    cdhCompanyId,
    cdhEmployeeId,
    operaCompanyId
  };
}
export function getUnleashTogglesServerOrClient(_x, _x2, _x3, _x4, _x5, _x6) {
  return _getUnleashTogglesServerOrClient.apply(this, arguments);
}
function _getUnleashTogglesServerOrClient() {
  _getUnleashTogglesServerOrClient = _asyncToGenerator(function* (cookies, label, flagsWithFallback, url, query, sessionTracing) {
    var _token$value, _ftOverride$value, _userIdCookie$value;
    var context = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    var ccuiSession = arguments.length > 7 ? arguments[7] : undefined;
    var flags = {};
    var token = cookies.get(ID_TOKEN_COOKIE);
    var idTokenCookie = typeof token === 'string' ? token : (_token$value = token === null || token === void 0 ? void 0 : token.value) !== null && _token$value !== void 0 ? _token$value : '';
    var ftOverride = cookies.get('ftOverride');
    var ftOverrideCookie = typeof ftOverride === 'string' ? ftOverride : (_ftOverride$value = ftOverride === null || ftOverride === void 0 ? void 0 : ftOverride.value) !== null && _ftOverride$value !== void 0 ? _ftOverride$value : '';
    var ftCookieObj = {};
    var userInfo = getUnleashUserInfo(idTokenCookie, ccuiSession);
    var unleashLogger = _objectSpread({
      label,
      pageLink: url,
      params: query,
      userInfo,
      flags,
      error: ''
    }, sessionTracing);
    if (ftOverrideCookie) {
      ftOverrideCookie.split(',').forEach(fs => {
        var _fs$split = fs.split('='),
          _fs$split2 = _slicedToArray(_fs$split, 2),
          key = _fs$split2[0],
          value = _fs$split2[1];
        if (key && value) {
          ftCookieObj[key] = value === 'true';
        }
      });
    }
    var userIdCookie = cookies.get('email');
    var userId = typeof userIdCookie === 'string' ? userIdCookie : (_userIdCookie$value = userIdCookie === null || userIdCookie === void 0 ? void 0 : userIdCookie.value) !== null && _userIdCookie$value !== void 0 ? _userIdCookie$value : '';
    var unleashContext = _objectSpread(_objectSpread({}, context), {}, {
      sessionId: sessionTracing['WB-SESSION-ID'],
      userId,
      environment: process.env.NEXT_ENV
    });
    var client = null;
    try {
      var _global$unleashClient, _global;
      client = (_global$unleashClient = (_global = global) === null || _global === void 0 ? void 0 : _global.unleashClient) !== null && _global$unleashClient !== void 0 ? _global$unleashClient : null;
    } catch (_unused) {
      unleashLogger.error = 'Unleash client not initialized, using fallback flags';
      logger.warn({
        label: 'UNLEASH_NOT_INITIALIZED',
        msg: 'Using fallback flags'
      });
    }
    Object.keys(flagsWithFallback).forEach(flag => {
      if (flag in ftCookieObj) {
        flags[flag] = ftCookieObj[flag];
      } else if (client) {
        flags[flag] = client.isEnabled(flag, unleashContext);
      } else {
        flags[flag] = flagsWithFallback[flag];
      }
    });
    logger.info(unleashLogger);
    return flags;
  });
  return _getUnleashTogglesServerOrClient.apply(this, arguments);
}